"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetName = exports.heroAlignment = exports.default = exports.cssAnchorName = exports.config = void 0;

var _preact = require("preact");

var _widgetContainer = _interopRequireWildcard(require("@insided/deprecated-preact-components/widget-container"));

var _zod = require("zod");

var _GenericHeroContainer = _interopRequireDefault(require("./GenericHeroContainer"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var widgetName = 'generic_hero';
exports.widgetName = widgetName;
var heroAlignment = ['left', 'center'];
exports.heroAlignment = heroAlignment;
var cssAnchorName = 'widget-generic_hero';
exports.cssAnchorName = cssAnchorName;

var config = _zod.z.object({
  heroImage: _zod.z.string().optional(),
  imageDescription: _zod.z.string().optional(),
  headline: _zod.z.string().optional(),
  tagline: _zod.z.string().optional(),
  categories: _zod.z.array(_zod.z.string()),
  productAreas: _zod.z.array(_zod.z.string()).optional(),
  align: _zod.z.enum(heroAlignment).optional()
}).merge(_widgetContainer.widgetContainerConfig);

exports.config = config;

var GenericHero = function GenericHero(_ref) {
  var align = _ref.align,
      backgroundColor = _ref.backgroundColor,
      backgroundColorDisplay = _ref.backgroundColorDisplay,
      title = _ref.title,
      subtitle = _ref.subtitle,
      heroImage = _ref.heroImage,
      imageDescription = _ref.imageDescription,
      hideSpacingWithUpperWidget = _ref.hideSpacingWithUpperWidget,
      paddingToTopAndBottom = _ref.paddingToTopAndBottom,
      isFederatedSalesforceSearch = _ref.isFederatedSalesforceSearch,
      isFederatedSkilljarSearch = _ref.isFederatedSkilljarSearch,
      isFederatedFreshdeskSearch = _ref.isFederatedFreshdeskSearch,
      tagline = _ref.tagline,
      headline = _ref.headline,
      titleColor = _ref.titleColor,
      titleColorDisplay = _ref.titleColorDisplay,
      subtitleColor = _ref.subtitleColor,
      subtitleColorDisplay = _ref.subtitleColorDisplay,
      searchRevamp = _ref.searchRevamp,
      aiSearchSummary = _ref.aiSearchSummary,
      isGuest = _ref.isGuest,
      aiSmartSearchEnableForAllRoles = _ref.aiSmartSearchEnableForAllRoles,
      liveSearchSuggestedQuestions = _ref.liveSearchSuggestedQuestions,
      _ref$categories = _ref.categories,
      categories = _ref$categories === void 0 ? [] : _ref$categories,
      _ref$productAreas = _ref.productAreas,
      productAreas = _ref$productAreas === void 0 ? [] : _ref$productAreas;
  var centered = align === 'center';
  return (0, _preact.h)(_widgetContainer.default, {
    widgetName: "generic_hero",
    config: {
      // we do not pass title/subtitle to the container
      // TODO: Introduce parameter noTitle and noSubtitle to be able to pass the whole config
      // or another, more sustainable approach
      backgroundColorDisplay: backgroundColorDisplay,
      backgroundColor: backgroundColor,
      hideSpacingWithUpperWidget: hideSpacingWithUpperWidget,
      paddingToTopAndBottom: paddingToTopAndBottom
    },
    boundedContext: "Search",
    entity: "GenericHero"
  }, (0, _preact.h)(_GenericHeroContainer.default, {
    centered: centered,
    title: title !== null && title !== void 0 ? title : headline,
    subtitle: subtitle !== null && subtitle !== void 0 ? subtitle : tagline,
    titleColor: titleColor,
    categories: categories,
    productAreas: productAreas,
    titleColorDisplay: titleColorDisplay,
    subtitleColor: subtitleColor,
    subtitleColorDisplay: subtitleColorDisplay,
    heroImage: heroImage,
    imageDescription: imageDescription,
    isFederatedSalesforceSearch: isFederatedSalesforceSearch,
    isFederatedSkilljarSearch: isFederatedSkilljarSearch,
    isFederatedFreshdeskSearch: isFederatedFreshdeskSearch,
    searchRevamp: searchRevamp,
    aiSearchSummary: aiSearchSummary,
    isGuest: isGuest,
    aiSmartSearchEnableForAllRoles: aiSmartSearchEnableForAllRoles,
    liveSearchSuggestedQuestions: liveSearchSuggestedQuestions
  }));
};

var _default = GenericHero;
exports.default = _default;